/**
 * @typedef {Object} SessionEvents
 * @property {string} unauthorized The name of the event triggered when the user tries to perform
 *                                 an action he/she is not authorized for.
 */

/**
 * A dictionary with all the custom session events names the app may need.
 * @type {SessionEvents}
 */
export const SESSION_EVENTS = {
  unauthorized: 'session:unauthorized',
};
